import * as types from "../actions/actionTypes";
const initialState = {
  loading: true,
  data: { data: [], links: {}, message: [], meta: {} },
  storeData: {},
  selected: {},
  error: false
};

const Activity = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ACTIVITY_REQUEST:
      return { ...state, loading: true };
    case types.GET_ACTIVITY_SUCCESS:
      return { ...state, selected: action.payLoad, loading: false };
    case types.GET_ACTIVITY_FAILURE:
      return { ...state, loading: false, error: true };

    case types.API_CALL_ACTIVITY_REQUEST:
      return { ...state, loading: true };
    case types.PUT_ACTIVITY:
      return { ...state, ...action.payLoad };

    case types.GET_DAILY_ACTIVITY_REQUEST:
      return { ...state, loading: true };
    case types.GET_DAILY_ACTIVITY_SUCCESS:
      return { ...state, ...action.payLoad };
    case types.GET_DAILY_ACTIVITY_FAILURE:
      return { ...state, ...action.payLoad, loading: false };

    case types.GET_MONTHLY_ACTIVITY_REQUEST:
      return { ...state, loading: true };
    case types.GET_MONTHLY_ACTIVITY_SUCCESS:
      return { ...state, ...action.payLoad };
    case types.GET_MONTHLY_ACTIVITY_FAILURE:
      return { ...state, ...action.payLoad, loading: false };

    case types.API_REMOVE_ACTIVITY_REQUEST:
      return { ...state, loading: true };

    case types.STORE_ACTIVITY_REQUEST:
      return { ...state, loading: true, error: false, deleted: false };
    case types.STORE_ACTIVITY_SUCCESS:
      return {
        ...state,
        storeData: action.storeData,
        deletedItemId: action.deletedItemId,
        loading: false,
        deleted: true
      };
    case types.STORE_ACTIVITY_FAILURE:
      return {
        ...state,
        storeData: action.storeData,
        deletedItemId: action.deletedItemId,
        loading: false,
        error: true,
        deleted: false
      };

    default:
      return state;
  }
};

export default Activity;
